import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';

class Infra {
    constructor(obj){
        Object.assign(this, obj)
    }
}

class Swagger {
    constructor(obj){
        Object.assign(this, obj)
    }
}


class InfraAPI extends API {

    url() {
        return config.get("re.url");
    }

    urlGlobal() {
        return config.get("re.urlGlobal") + "infra";
    }
    
    urlSwagger() {
        return config.get("re.domain");
    }


    create(stack) {
        return new Promise((resolve, reject) => {
            axios.post(
                this.urlGlobal() + "/create",
                stack,
                this._getHeaders(),
            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to create the stack", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    reloadMetadata(stackToRealodMetadata) {
        
        return new Promise((resolve, reject) => {
            axios.post(
                this.urlGlobal() + "/stacks/reload/metadata",
                stackToRealodMetadata,
                this._getHeaders(),
            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to Realod the database metadata", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    restart(stack) {
        return new Promise((resolve, reject) => {
            const service = stack.services.find((service)=>{
                return service.node === "metadata"
            })
            axios.put(
                this.urlGlobal() + `/stacks/${stack.stack_id}/services/${service.id}/restart`,
                stack,
                this._getHeaders(),
            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to restart the stack", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
    destroy(stack) {
        return new Promise((resolve, reject) => {
            axios.delete(
                this.urlGlobal() + `/destroy/${stack.app_id}~~${stack.stack_id}`,
                this._getHeaders(),
            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to destroy the stack", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    // Funciona para conocer el progreso de avance del todos los servicios de un stack en particular.
    // El mismo va retornando en qué etapa está en términos porcentuajes y qué acción específica se está realizando.
    getPlatformEvents (appId, tokenAdmin, date, maxEvent, eventType) {
        
        if (!appId){
            return new []();
        }
        return new Promise((resolve, reject) => {

            // TODO Mejorar las llamadas a este metodo getPlatformEvents a fin de enviar los parametros de los filtros de forma eficiente. Ej. pasar "STARTUP" en eventType y menos registros en "maxEvent"
            const eventTypeFiltered = (eventType)?"&event_type="+eventType:"&event_type=STARTUP";
            const maxEventFiltered = (maxEvent)?"&regxpag="+maxEvent:"&regxpag=1000";
            
            // Fecha inicio por defecto (Ejemplo para tomar la fecha actual luego de importar "moment" en el .js: datetime:moment(new Date()).format();)
            // const dateByDefault= "2020-01-01T00:00:00-03:00";
            // const dateByDefault = moment(new Date()).subtract("00:01:10").format();
            // const dateByDefault= moment(new Date()).format();

            // Se obtiene la fecha de inicio de la creación del stack (indica el momento en que se comenzó a inicializar.
            // Es decir, NO es el momento en que finalizó la creación, ya que el mismo pudo haber terminado N horas o minutos más tarde)
            // const stackCreatedAt = (date)?date:dateByDefault;
                        
            // Viejo ejemplo de la URI que se invocaba antes: https://sinexiar.com/smre/1.0/platform_events_startup?account_id=3&app_id=5&created_at=gte:2021-10-17T21:00:00-03:00&regxpag=500&direction=1
            const url = this.url() + `/applications/${appId}/platform_events_startup?created_at=gte:${date + eventTypeFiltered +maxEventFiltered}&direction=1`;
            
            // Se pisa el header para incorporar el Token de "usuario admin/root".
            // El servicio "platform_events_startup" puede ser consultado únicamente por usuarios ROOT o Admin de los stacks relativos a su "cuenta".
            const headerWithToken={
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    "Authorization" : "Bearer "+ tokenAdmin
                }
            }
            axios.get(              
                url,
                headerWithToken
            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Error: Could not get events in getPlatformEvents with those parameters seted", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                console.log("ERROR getPlatformEvents: " + err)
                reject(err);
            });
        });
    }

    // Funciona para conocer la última notificación del último evento conocido por el stack.
    getPlatformLastEvent (appId, tokenAdmin) {
        
        if (!appId){
            return null;
        }
        return new Promise((resolve, reject) => {
                        
            // Ejemplo de la URI que se debe invocar: https://sinexiar.com/smre/infra/info/applications/{Bapp_id}/stack/events
            const url = this.urlGlobal() + `/info/applications/${appId}/stack/events`;
            
            axios.get(              
                url,
                this._getHeaders(),
            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Error: Could not get last event in getPlatformLastEvent", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                console.log("ERROR getPlatformLastEvent: " + err)
                reject(err);
            });
        });
    }
    

    getStackFromApp(appId) {
        return new Promise((resolve, reject) => {
            axios.get(
                this.url() + "stackapplication?app_id="+appId,
                this._getHeaders(),

            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    if(response.data.stackapplication.length > 0){
                        console.log("getStackFromApp idApp=" + appId + " stack (Infra): " + response.data.stackapplication[0]);
                        resolve(new Infra(response.data.stackapplication[0]));
                    }else {                        
                        console.log("getStackFromApp idApp=" + appId + " THERE IS NO STACK DETECTEED!");
                        resolve(null)
                    }
                } else {                    
                    console.log("getStackFromApp NO hay STACK. Responding widh HTTP Status: " + response.status);
                    const err = new Error(response.status, "Failed to fetch stack", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    getSwagger(appInstance_name) {
        return new Promise((resolve, reject) => {
            axios.get(
                this.urlSwagger() + `${appInstance_name}/swagger/catalog-endpoints`,
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to fetch swagger", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }
}

export {
    InfraAPI, Infra, Swagger
};